import { useEffect } from "react";
import { Outlet, useLocation } from "react-router-dom";
import { Header } from "@/components/Header";
import { Footer } from "@/components/Footer";
import { FloatingCTA } from "@/components/FloatingCTA";
import { KanjiBackground } from "@/components/KanjiBackground";
import { AnnouncementBar } from "@/components/AnnouncementBar";

export const Layout = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "instant" });
  }, [pathname]);

  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <KanjiBackground />
      <AnnouncementBar />
      <Header />
      <main className="relative z-10 flex-1">
        <Outlet />
      </main>
      <div className="relative z-10">
        <Footer />
      </div>
      <FloatingCTA />
    </div>
  );
};
